module.exports = "/static-assets/_next/static/images/phone-handset-efbd9967fb355780e128595c5b6998c8.png";